import { cameraPostion } from './../store/navigationSlice.class';
import { useGroups } from '@k3/core'
import { Vector3 } from '@react-three/fiber'
import { useMontage } from '../../context/montage.context'
interface CameraPositions {
  [key: string]: number[]
}

interface CameraEgoPositions {
  [key: string]: number[]
}

/**
 * Keeps track of the camera postion when a navigation tab is clicked
 * @author Sandro Müller
 *
 */
export abstract class ThreeCamera {
  /**
   * Camera positions for each navigation tab
   */
  static cameraPositions: CameraPositions = {
    umgebung: [6, 4, 8],
    grunddaten: [0, 5, 9],
    maße: [6, 4, 8],
    terassendach: [-3, 4, 5],
    markise: [0, 7, 7],
    seitenwandrechts: [6, 2, 0],
    seitenwandlinks: [-6, 2, 0],
    seitenwandvornerechts: [6, 2, 6],
    seitenwandvornemitte: [0, 2, 6],
    seitenwandvornelinks: [-6, 2, 6],
    zubehr: [6, 1, 1],
  }

  /**
   * Camera positions for each navigation tab on Ego perspective
   */
  static cameraEgoPositions: CameraEgoPositions = {
    umgebung: [0, 1, 0.005],
    grunddaten: [0, 1, 0.005],
    maße: [0, 1, 0.005],
    terassendach: [0, 0.5, 0.005],
    markise: [0, 0, 0.005],
    seitenwandrechts: [-1.2, 0.8, 0.005],
    seitenwandlinks: [1.2, 0.8, 0.005],
    seitenwandvornerechts: [-1.2, 0.8, 0.005],
    seitenwandvornemitte: [0, 0.8, 0.005],
    seitenwandvornelinks: [1.2, 0.8, 0.005],
    zubehr: [0, 0.1, 0.005],
    ego: [0, 1, 0.005],
  }

  static startPosition = [6, 4, 8] as Vector3

  static cameraFov = 50

  /**
   * Helps to return the camera postion for the interacted panel
   * @param event MouseEvent to extract DOM text
   * @returns The camera position for each navigation panel
   */
  public static cameraPostion(event: { target: HTMLElement }, measure: any, attachment: string): number[] | null {

    const tag = event.target.tagName
    const text = event.target.textContent
    const key = this.extractString(text as string)
    const position = this.setPosition(key, measure, attachment)

    //! TODO: Change by data-attr + consider depth and width of terraceCover
    if (tag !== 'SPAN' && tag !== 'DIV') return null
    return position
    // return this.cameraPositions[key]
  }

  public static cameraEgoPostion(event: { target: HTMLElement }, measure: any, attachment: string): number[] | null {
    const tag = event.target.tagName
    const text = event.target.textContent
    const key = this.extractString(text as string)

    console.log(tag)
    //! TODO: Change by data-attr + consider depth and width of terraceCover
    if (tag !== 'SPAN' && tag !== 'DIV' && tag !== 'INPUT') return null
    const position = this.setEgoPosition(key, measure, attachment)
    return position
  }

  /**
   * Helper method for cameraPosition()
   * @param text DOM text that needs to be modified
   * @returns string
   */
  private static extractString(text: string): string {

    const split1 = text.replace(' ', '')
    const replace = split1.replace(/[^a-z0-9]/gi, '')
    const split = replace.split('-')[0]
    return split.toLowerCase()
  }

  private static setPosition(text: string, measure: any, attachment: string): number[] {

    switch (text) {
      case 'seitenwandlinks':
        return [-6 - ((measure.userWidth / 100 - 3) / 2), 2, 0]
      case 'seitenwandrechts':
        return [6 + ((measure.userWidth / 100 - 3) / 2), 2, 0]
      case 'terassendach':
        return [-3 - ((measure.userWidth / 100 - 3) / 4), 4, 5]
      default:
        return this.cameraPositions[text]
    }

  }

  private static setEgoPosition(text: string, measure: any, attachment: string): number[] {
    if (attachment === 'Freistehend') {
      if (text === '') {
        this.cameraEgoPositions.ego[2] = 0.4
        return this.cameraEgoPositions.ego
      } else {
        this.cameraEgoPositions[text][2] = 0.4
        return this.cameraEgoPositions[text]
      }

    }

    if (text === '') {
      this.cameraEgoPositions.ego[2] = 0.005
      return this.cameraEgoPositions.ego
    } else {
      this.cameraEgoPositions[text][2] = 0.005

    }

    return this.cameraEgoPositions[text]
  }

}
